import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom"
import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from "@sentry/react";
import './index.css'
import { Provider } from 'react-redux'
import { store } from './redux'
import routes from './routes'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { TCS } from './constants/TCS/TCS'
import { config } from './config';

if (config.alerts) {
  Sentry.init({
    dsn: config.sentryDsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    environment: config.env,
    tracesSampleRate: 1.0,
    tracePropagationTargets: [config.apiUrl],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={config.env === 'production' ? TCS.GOOGLE_AUTH_CLIENT_ID_PRODUCTION as string : TCS.GOOGLE_AUTH_CLIENT_ID_SANDBOX as string}>
      <Provider store={store}>
        <Router>
          <Routes>
            {routes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}
          </Routes>
        </Router>
      </Provider>
    </GoogleOAuthProvider>
  </React.StrictMode>,
)
